// This dependency typically gets called immediately since its apart of SEO routes so it needed to be separated from constants.mts file
// More experimentation of the dependency tree needs to be tested to see if separating this record is even an optimization
// Until I conduct that test, its better to be safe and separate it for now
export const HEROES_TO_ARTICLE_ID = {
  Hulk: "3XRjKiO6zu6Bw0QF7SnlJr",
  "Doctor Strange": "2qDKv3bI47h8iUdr4RqEBi",
  "Captain America": "7jZjyy2wOmbVDodsCHo91h",
  Groot: "5TX9zLgYf2GEwIH7g5DAXq",
  Venom: "632GrpjFKgql803kONtczz",
  Magneto: "zYjCQpPfTWo1AegI9EsJ0",
  Thor: "2YPmwmyZ7MzxXjEQxeP7ut",
  "Peni Parker": "2e9s4TenoUizAAJCw7hQtP",
  "The Punisher": "1Eb1o2lyQsJrCeRVkCw0fV",
  Storm: "E0HSr1NoN532IvniuEw3Y",
  Hawkeye: "6v8Wy9u8yizHitM5uXWQr9",
  Hela: "75mrwxqu6ckgqmjhmq6yxH",
  "Black Panther": "PBprAEFJtcJnMsS7vYjFR",
  Magik: "7rQ0lFUy5eFMWb3amwyDBH",
  "Moon Knight": "52opBvN82uVxUChABMOgJN",
  "Squirrel Girl": "4iRT9agTdeOCSjImGq61Ax",
  "Black Widow": "5srR9IYb8URUaiBJeK96Ol",
  "Iron Man": "Bb2D0RkuW9TcIBxdiHE6J",
  "Spider-Man": "2Lxi8oVFs2mF28FPC2dkkH",
  "Scarlet Witch": "vX7quxEOxMGdJ5VIfHj2z",
  "Winter Soldier": "46vonMdhhUaiKLzkdTzNgG",
  "Star-Lord": "67UF0cfEw1COYQUet7GsM6",
  Namor: "rIVR4OAi6nUBAAsSZEiUg",
  Psylocke: "mSSmEivFpy9acKwEPA581",
  Wolverine: "6n9io7YKYtkGBCRUrmiSvn",
  "Iron Fist": "9lhFlAJf6484cQUxF2zSp",
  Loki: "4NatxaZs0IpZe1xxSwM5Gt",
  Mantis: "5WiIKfxZhcFc6mhWuy1twH",
  "Rocket Raccoon": "3Mh7BFiFBjxzjQWfAWWKC1",
  "Cloak & Dagger": "o89uKVywEDGamTHnWPyHc",
  "Luna Snow": "7g35ZNsikdcnuddONtpEPv",
  "Adam Warlock": "7qNlGulzcuki0mhsKwcXT6",
  "Jeff the Land Shark": "3uFTiYAEwH4nyuNyMkEMa8",
  "Mister Fantastic": "3XkJHPQqCeI3Yg2tJHjXEf",
  "Invisible Woman": "3LK4JRZyhPFn7U2JQN1sv0",
};
